import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import {
  fetchMasterList,
  fetchMasterListById,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";

const ChecklistForm = (props) => {
  let [name, setName] = useState("");
  let [edit, setEdit] = useState(false);
  let [id, setId] = useState("");
  let [deptCode, setDeptCode] = useState();
  let [deptName, setDeptName] = useState();
  const [validate, setValidate] = useState(false);
  let [status, setStatus] = useState("Active");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [machineCode, setMachineCode] = useState("");
  const [machineName,setMachineName] = useState("")
  const [checklistTypeCode, setChecklistTypeCode] = useState("");
  const [checklistTypeName, setChecklistTypeName] = useState("");
  const [deptError, setDeptError] = useState(false);
  const [machineError, setMachineError] = useState(false);
  const [machineValue, setMachineValue] = useState();
  useEffect(() => {
    if (props.data.checklistCode) {
      setName(props?.data?.checklistName);
      setId(props?.data?.checklistCode);
      setStatus(props?.data?.checklistStatus);
      setDeptCode(props?.data?.deptCode);
      setDeptName(props?.data?.deptName);
      setMachineCode(props?.data?.machineCode);
      setMachineName(props?.data?.machineName);
      setChecklistTypeCode(props?.data?.checklistTypeCode);
      setChecklistTypeName(props?.data?.checklistTypeName);
      handleMachineByDept(props?.data?.deptCode,props?.data?.machineName,false);
      setEdit(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let deptList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.DEPARTMENT.name]?.data
  ); // User Details from Store
  useEffect(() => {
    if (!deptList) {
      dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deptResult =
  deptList &&
  deptList.map(({ deptCode, deptName }) => ({ deptCode, deptName: `${deptCode} - ${deptName}` }));

    let checkListType = useSelector(
      (state) => state?.masterList?.page[Constants.MASTER.CHECKLIST_TYPE.name]?.data
    ); // User Details from Store
  
    useEffect(() => {
      if (!checkListType) {
        dispatch(fetchMasterList(Constants.MASTER.CHECKLIST_TYPE));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  
    const checkListTypeResult =
      checkListType && checkListType.map(({ code, name }) => ({ code, name }));
  
  const handleSave = (event) => {
    const form = formRef.current;
    if (!deptCode ) {
      setDeptError(true);
      return 
    } else if( !machineCode) {
      setMachineError(true);
      return 
    }

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      const checklistObj = {
        deptCode,
        deptName,
        machineCode: machineCode,
        machineName: machineName,
        checklistCode: id,
        checklistName: name,
        checklistStatus: status,
        checklistTypeCode: checklistTypeCode,
        checklistTypeName: checklistTypeName,
      };
      if (edit) {
        checklistObj._id = props.data._id;
      }
      props.onSave(checklistObj, edit);
      setName("");
      setId("");
      setEdit(false);
    }
  };

  const handleCancel = (event) => {
    setName("");
    setId("");
    props.onHide();
  };

  const handleMachineByDept = (deptCode, deptName,clearInd = true) => {
    setDeptCode(deptCode);
    setDeptName(deptName);
    let param = {};
    param.url = "getMasterListDataById";
    param.page = Constants.MASTER.MACHINES.name;
    param.id = deptCode;
    dispatch(fetchMasterListById(param)).then((result) => {
      console.log("machineResult",result)
       const machineResult =
        result?.payload?.data &&
        result?.payload?.data.map(({ machineCode, machineName }) => {
          return {
          machineCode,
          machineName,
        }
      });
      setMachineValue(machineResult);
      if(clearInd) {
      setMachineCode("");
      setMachineName("");
    }
    });
  };

  const { show, onHide } = props;
  return (
    <Modal show={show} onHide={onHide} animation={false} backdrop="static">
      <ModalHeader
        title={
          edit
            ? t("msg_master_list.msg_checklist.edit_page_title")
            : t("msg_master_list.msg_checklist.page_title")
        }
      ></ModalHeader>
      <ModalBody>
        <Form noValidate validated={validate} ref={formRef}>
          <Form.Group className="mb-3">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_checklist.select_department")}
            </Form.Label>
            <DropdownListField
              id="deptCode"
              name="deptName"
              className="dropdownHive w-full rounded-md"
              data={deptResult}
              value={deptCode}
              onChange={(value) => {
                handleMachineByDept(value.deptCode, value.deptName);
                setDeptError(false);
              }
              }
              required
              placeholder={t("msg_master_list.msg_machines.select_department")}
              autoFocus={true}
              error={deptError}
              disabled={!deptResult}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_checklist.select_machines")}
            </Form.Label>
            <DropdownListField
              id="machineCode"
              name="machineCode"
              className="dropdownHive w-full rounded-md"
              data={machineValue}
              value={machineCode}
              required
              onChange={(value) => {setMachineCode(value?.machineCode);setMachineName(value?.machineName); setMachineError(false); }}
              placeholder={t("msg_master_list.msg_checklist.select_machines")}
              autoFocus={false}
              error={machineError}
              disabled={!machineValue}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_checklist.checklistType")} :
            </Form.Label>
            <DropdownListField
              id="code"
              name="name"
              className="dropdownHive w-full rounded-md"
              data={checkListTypeResult}
              value={checklistTypeCode}
              onChange={(value) => {setChecklistTypeCode(value?.code); setChecklistTypeName(value?.name);}}
              placeholder={t("msg_master_list.msg_checklist.select_checklistType")}
              autoFocus={true}
              disabled={props?.data?.category === "ADMIN" ? true : false}
            />
        </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_checklist.code")} :
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g: CHK-001"
              value={id || ""}
              onChange={(e) => setId(e.target.value?.trim()?.toUpperCase())}
              required
              maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_checklist.checklist_code_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {" "}
              {t("msg_master_list.msg_checklist.checklist_name")} :
            </Form.Label>
            <Form.Control
              type="text"
              value={name || ""}
              onChange={(e) => setName(e.target.value)}
              required
              maxLength={Constants.MASTER.VALIDATION.maxLengthName}
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_checklist.checklist_name_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_common.status")} :
            </Form.Label>
            <Form.Select
              aria-label="select status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="Active">{t("msg_common.active")}</option>
              <option value="Inactive">{t("msg_common.inactive")}</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          variant="success"
          className="btn btn-success"
          onClick={handleSave}
        >
          {t("msg_common.save")}
        </Button>
        <Button
          type="button"
          variant="danger"
          className="btn btn-danger"
          onClick={handleCancel}
          data-dismiss="modal"
        >
          {t("msg_common.cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ChecklistForm;
